/** 选中某个元素的文本 */
export function selectText(target) {
  if (!target || !target.ownerDocument) return;
  try {
    var _target$ownerDocument;
    const range = target.ownerDocument.createRange();
    range.selectNodeContents(target);
    const selection = (_target$ownerDocument = target.ownerDocument) === null || _target$ownerDocument === void 0 || (_target$ownerDocument = _target$ownerDocument.defaultView) === null || _target$ownerDocument === void 0 ? void 0 : _target$ownerDocument.getSelection();
    if (!selection) return;
    selection.removeAllRanges();
    selection.addRange(range);
  } catch (e) {
    console.error(e);
  }
}